// extracted by mini-css-extract-plugin
export default {"teamInfo":"TeamSelectComponent_teamInfo__QO6hX","teamsPicker":"TeamSelectComponent_teamsPicker__1VCBe"};